<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Application" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row">
    <div class="col-lg-12">
        <div class="card" id="applicationList">
            <div class="card-header  border-0">
                <div class="d-md-flex align-items-center">
                    <h5 class="card-title mb-3 mb-md-0 flex-grow-1">Job Application</h5>
                    <div class="flex-shrink-0">
                        <div class="d-flex gap-1 flex-wrap">
                            <button type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn" data-bs-target="#showModal" (click)="openModel(content)"><i class="ri-add-line align-bottom me-1"></i> Create
                                Application</button>
                            <button type="button" class="btn btn-info"><i class="ri-file-download-line align-bottom me-1"></i> Import</button>
                            <button class="btn btn-soft-danger" id="remove-actions" (click)="confirm(deletemodal,'')"><i class="ri-delete-bin-2-line"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body border border-dashed border-end-0 border-start-0">
                <!-- <form> -->
                <div class="row g-3">
                    <div class="col-xxl-5 col-sm-6">
                        <div class="search-box">
                            <input type="text" class="form-control search" placeholder="Search for application ID, company, designation status or something..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-6">
                        <div>
                            <input type="text" class="form-control" mwlFlatpickr [convertModelValue]="true" placeholder="Select date" [(ngModel)]="date" mode="range">
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-4">
                        <div>
                            <select class="form-control" data-choices data-choices-search-false name="choices-single-default" id="idStatus" [(ngModel)]="status" (ngModelChange)="statusFilter()">
                                <option value="">Status</option>
                                <option value="" selected>All</option>
                                <option value="Approved">Approved</option>
                                <option value="New">New</option>
                                <option value="Pending">Pending</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-4">
                        <div>
                            <select class="form-control" data-choices data-choices-search-false name="choices-single-default" id="idType" [(ngModel)]="type" (ngModelChange)="typeFilter()">
                                <option value="">Select Type</option>
                                <option value="" selected>All</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                            </select>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-1 col-sm-4">
                        <div>
                            <button type="button" class="btn btn-primary w-100" onclick="filterData();"> <i class="ri-equalizer-fill mx-1 align-bottom"></i>
                                Filters
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                </div>
                <!--end row-->
                <!-- </form> -->
            </div>
            <div class="card-body pt-0">
                <div>
                    <ul ngbNav #nav="ngbNav" [activeId]="1" (navChange)="onNavChange($event)" class="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                        <li [ngbNavItem]="1" class="nav-item">
                            <a ngbNavLink class="nav-link All py-3" data-bs-toggle="tab" id="All" href="javascript:void(0);" role="tab" aria-selected="true">
                                All Application
                            </a>
                            <ng-template ngbNavContent>
                                <table class="table table-nowrap align-middle" id="jobListTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <th scope="col" style="width: 25px;">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                                </div>
                                            </th>
                                            <th class="sort" (click)="onSort('id')" (appsort)="onSort($event)" style="width: 140px;">Application ID</th>
                                            <th class="sort" (click)="onSort('name')" (appsort)="onSort($event)">Company
                                                Name</th>
                                            <th class="sort" (click)="onSort('designation')" (appsort)="onSort($event)">
                                                Designation</th>
                                            <th class="sort" (click)="onSort('date')" (appsort)="onSort($event)">Apply Date
                                            </th>
                                            <th class="sort" (click)="onSort('contacts')" (appsort)="onSort($event)">Contacts
                                            </th>
                                            <th class="sort" (click)="onSort('type')" (appsort)="onSort($event)">Type</th>
                                            <th class="sort" (click)="onSort('status')" (appsort)="onSort($event)">Status</th>
                                            <th class="sort">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        @for ( data of applications; track $index) {
                                        <tr id="a_{{data.id}}">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="checkAll" value="{{data.id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                                </div>
                                            </th>
                                            <td class="id"><a href="javascript:void(0);" class="fw-medium link-primary">#VZ{{data.id}}</a>
                                            </td>
                                            <td class="company">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <img src="{{data.img}}" alt="" class="avatar-xxs rounded-circle image_src object-fit-cover">
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">{{data.name}}</div>
                                                </div>
                                            </td>
                                            <td class="designation">{{data.designation}}</td>
                                            <td class="date">{{data.date}}</td>
                                            <td class="contacts">{{data.contacts}}</td>
                                            <td class="type">{{data.type}}</td>
                                            <td class="status">
                                                <span class="badge text-uppercase" [ngClass]="{'bg-danger-subtle text-danger': data.status == 'Rejected','bg-info-subtle text-info': data.status == 'New',
                                                    'bg-warning-subtle text-warning': data.status == 'Pending','bg-success-subtle text-success': data.status == 'Approved'}">
                                                    {{data.status}}</span>

                                            </td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="View">
                                                        <a routerLink="/job-lists/overview" class="text-primary d-inline-block">
                                                            <i class="ri-eye-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Edit" (click)="editorder(content,$index)">
                                                        <a data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item me-0" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Remove">
                                                        <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" (click)="confirm(deletemodal,data.id)">
                                                            <i class="ri-delete-bin-5-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2" class="nav-item">
                            <a ngbNavLink class="nav-link py-3 New" data-bs-toggle="tab" id="New" href="javascript:void(0);" role="tab" aria-selected="false">
                                New
                            </a>
                            <ng-template ngbNavContent>
                                <table class="table table-nowrap align-middle" id="jobListTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <th scope="col" style="width: 25px;">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                                </div>
                                            </th>
                                            <th class="sort" data-sort="id" style="width: 140px;">Application ID</th>
                                            <th class="sort" data-sort="company">Company Name</th>
                                            <th class="sort" data-sort="designation">Designation</th>
                                            <th class="sort" data-sort="date">Apply Date</th>
                                            <th class="sort" data-sort="contacts">Contacts</th>
                                            <th class="sort" data-sort="type">Type</th>
                                            <th class="sort" data-sort="status">Status</th>
                                            <th class="sort" data-sort="city">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        @for ( data of applications; track $index) {
                                        <tr id=" a_{{data.id}}">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="checkAll" value="{{data.id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                                </div>
                                            </th>
                                            <td class="id"><a href="javascript:void(0);" class="fw-medium link-primary">#VZ{{data.id}}</a>
                                            </td>
                                            <td class="company">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <img src="{{data.img}}" alt="" class="avatar-xxs rounded-circle image_src object-fit-cover">
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">{{data.name}}</div>
                                                </div>
                                            </td>
                                            <td class="designation">{{data.designation}}</td>
                                            <td class="date">{{data.date}}</td>
                                            <td class="contacts">{{data.contacts}}</td>
                                            <td class="type">{{data.type}}</td>
                                            <td class="status">
                                                <span class="badge text-uppercase" [ngClass]="{'bg-danger-subtle text-danger': data.status == 'Rejected','bg-info-subtle text-info': data.status == 'New',
                                                    'bg-warning-subtle text-warning': data.status == 'Pending','bg-success-subtle text-success': data.status == 'Approved'}">
                                                    {{data.status}}</span>

                                            </td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="View">
                                                        <a routerLink="/job-lists/overview" class="text-primary d-inline-block">
                                                            <i class="ri-eye-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Edit" (click)="editorder(content,$index)">
                                                        <a data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item me-0" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Remove">
                                                        <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" (click)="confirm(deletemodal,data.id)">
                                                            <i class="ri-delete-bin-5-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3" class="nav-item">
                            <a ngbNavLink class="nav-link py-3 Pending" data-bs-toggle="tab" id="Pending" href="javascript:void(0);" role="tab" aria-selected="false">
                                Pending <span class="badge bg-danger align-middle ms-1">2</span>
                            </a>
                            <ng-template ngbNavContent>
                                <table class="table table-nowrap align-middle" id="jobListTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <th scope="col" style="width: 25px;">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                                </div>
                                            </th>
                                            <th class="sort" data-sort="id" style="width: 140px;">Application ID</th>
                                            <th class="sort" data-sort="company">Company Name</th>
                                            <th class="sort" data-sort="designation">Designation</th>
                                            <th class="sort" data-sort="date">Apply Date</th>
                                            <th class="sort" data-sort="contacts">Contacts</th>
                                            <th class="sort" data-sort="type">Type</th>
                                            <th class="sort" data-sort="status">Status</th>
                                            <th class="sort" data-sort="city">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        @for ( data of applications; track $index) {
                                        <tr id="a_{{data.id}}">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="checkAll" value="{{data.id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                                </div>
                                            </th>
                                            <td class="id"><a href="javascript:void(0);" class="fw-medium link-primary">#VZ{{data.id}}</a>
                                            </td>
                                            <td class="company">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <img src="{{data.img}}" alt="" class="avatar-xxs rounded-circle image_src object-fit-cover">
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">{{data.name}}</div>
                                                </div>
                                            </td>
                                            <td class="designation">{{data.designation}}</td>
                                            <td class="date">{{data.date}}</td>
                                            <td class="contacts">{{data.contacts}}</td>
                                            <td class="type">{{data.type}}</td>
                                            <td class="status">
                                                <span class="badge text-uppercase" [ngClass]="{'bg-danger-subtle text-danger': data.status == 'Rejected','bg-info-subtle text-info': data.status == 'New',
                                                    'bg-warning-subtle text-warning': data.status == 'Pending','bg-success-subtle text-success': data.status == 'Approved'}">
                                                    {{data.status}}</span>

                                            </td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                        <a routerLink="/job-lists/overview" class="text-primary d-inline-block">
                                                            <i class="ri-eye-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Edit" (click)="editorder(content,$index)">
                                                        <a data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item me-0" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Remove">
                                                        <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" (click)="confirm(deletemodal,data.id)">
                                                            <i class="ri-delete-bin-5-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="4" class="nav-item">
                            <a ngbNavLink class="nav-link py-3 Approved" data-bs-toggle="tab" id="Approved" href="javascript:void(0);" role="tab" aria-selected="false">
                                Approved
                            </a>
                            <ng-template ngbNavContent>
                                <table class="table table-nowrap align-middle" id="jobListTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <th scope="col" style="width: 25px;">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                                </div>
                                            </th>
                                            <th class="sort" data-sort="id" style="width: 140px;">Application ID</th>
                                            <th class="sort" data-sort="company">Company Name</th>
                                            <th class="sort" data-sort="designation">Designation</th>
                                            <th class="sort" data-sort="date">Apply Date</th>
                                            <th class="sort" data-sort="contacts">Contacts</th>
                                            <th class="sort" data-sort="type">Type</th>
                                            <th class="sort" data-sort="status">Status</th>
                                            <th class="sort" data-sort="city">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        @for ( data of applications; track $index) {
                                        <tr id="a_{{data.id}}">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="checkAll" value="{{data.id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                                </div>
                                            </th>
                                            <td class="id"><a href="javascript:void(0);" class="fw-medium link-primary">#VZ{{data.id}}</a>
                                            </td>
                                            <td class="company">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <img src="{{data.img}}" alt="" class="avatar-xxs rounded-circle image_src object-fit-cover">
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">{{data.name}}</div>
                                                </div>
                                            </td>
                                            <td class="designation">{{data.designation}}</td>
                                            <td class="date">{{data.date}}</td>
                                            <td class="contacts">{{data.contacts}}</td>
                                            <td class="type">{{data.type}}</td>
                                            <td class="status">
                                                <span class="badge text-uppercase" [ngClass]="{'bg-danger-subtle text-danger': data.status == 'Rejected','bg-info-subtle text-info': data.status == 'New',
                                                    'bg-warning-subtle text-warning': data.status == 'Pending','bg-success-subtle text-success': data.status == 'Approved'}">
                                                    {{data.status}}</span>

                                            </td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                        <a routerLink="/job-lists/overview" class="text-primary d-inline-block">
                                                            <i class="ri-eye-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Edit" (click)="editorder(content,$index)">
                                                        <a data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item me-0" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Remove">
                                                        <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" (click)="confirm(deletemodal,data.id)">
                                                            <i class="ri-delete-bin-5-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="5" class="nav-item">
                            <a ngbNavLink class="nav-link py-3 Rejected" data-bs-toggle="tab" id="Rejected" href="javascript:void(0);" role="tab" aria-selected="false">
                                Rejected
                            </a>
                            <ng-template ngbNavContent>
                                <table class="table table-nowrap align-middle" id="jobListTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <th scope="col" style="width: 25px;">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                                </div>
                                            </th>
                                            <th class="sort" data-sort="id" style="width: 140px;">Application ID</th>
                                            <th class="sort" data-sort="company">Company Name</th>
                                            <th class="sort" data-sort="designation">Designation</th>
                                            <th class="sort" data-sort="date">Apply Date</th>
                                            <th class="sort" data-sort="contacts">Contacts</th>
                                            <th class="sort" data-sort="type">Type</th>
                                            <th class="sort" data-sort="status">Status</th>
                                            <th class="sort" data-sort="city">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        @for ( data of applications; track $index) {
                                        <tr id="a_{{data.id}}">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="checkAll" value="{{data.id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                                </div>
                                            </th>
                                            <td class="id"><a href="javascript:void(0);" class="fw-medium link-primary">#VZ{{data.id}}</a>
                                            </td>
                                            <td class="company">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <img src="{{data.img}}" alt="" class="avatar-xxs rounded-circle image_src object-fit-cover">
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">{{data.name}}</div>
                                                </div>
                                            </td>
                                            <td class="designation">{{data.designation}}</td>
                                            <td class="date">{{data.date}}</td>
                                            <td class="contacts">{{data.contacts}}</td>
                                            <td class="type">{{data.type}}</td>
                                            <td class="status">
                                                <span class="badge text-uppercase" [ngClass]="{'bg-danger-subtle text-danger': data.status == 'Rejected','bg-info-subtle text-info': data.status == 'New',
                                                    'bg-warning-subtle text-warning': data.status == 'Pending','bg-success-subtle text-success': data.status == 'Approved'}">
                                                    {{data.status}}</span>

                                            </td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                        <a routerLink="/job-lists/overview" class="text-primary d-inline-block">
                                                            <i class="ri-eye-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Edit" (click)="editorder(content,$index)">
                                                        <a data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item me-0" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" ngbTooltip="Remove">
                                                        <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" (click)="confirm(deletemodal,data.id)">
                                                            <i class="ri-delete-bin-5-fill fs-16"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </ng-template>
                        </li>
                    </ul>

                    <!-- Tab Pane -->
                    <div class="table-responsive table-card mb-1">
                        <div [ngbNavOutlet]="nav"></div>
                        <div class="noresult" style="display: none">
                            <div class="text-center">
                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style="width:75px;height:75px">
                                </lord-icon>
                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                <p class="text-muted">We've searched more than 150+ result We did not find jobs for you
                                    search.</p>
                            </div>
                        </div>
                    </div>
                    <!-- pagination -->
                    <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="allapplications?.length" [(page)]="service.page" [pageSize]="service.pageSize" (pageChange)="changePage()" aria-label="Custom pagination">
                        <ng-template ngbPaginationPrevious let-page let-pages="pages">
                            <i class="ci-arrow-left me-2"></i>
                            Prev
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            Next
                            <i class="ci-arrow-right ms-2"></i>
                        </ng-template>
                    </ngb-pagination>

                    <div id="elmLoader">
                        <div class="spinner-border text-primary avatar-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>


                <!-- Modal -->
                <ng-template #content role="document" let-modal>
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">Add Application&nbsp;</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="modal.dismiss('close click')" id="close-modal"></button>
                    </div>
                    <form action="#" autocomplete="off" (ngSubmit)="createapplication()" [formGroup]="applicationData">
                        <div class="modal-body">

                            <div class="mb-3 d-none" id="modal-id">
                                <label for="applicationId" class="form-label">ID</label>
                                <input type="hidden" id="applicationId" class="form-control" placeholder="ID" formControlName="id" readonly />
                            </div>

                            <div class="text-center">
                                <div class="position-relative d-inline-block">
                                    <div class="position-absolute  bottom-0 end-0">
                                        <label for="companylogo-image-input" class="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" ngbTooltip="Select Image">
                                            <div class="avatar-xs cursor-pointer">
                                                <div class="avatar-title bg-light border rounded-circle text-muted">
                                                    <i class="ri-image-fill"></i>
                                                </div>
                                            </div>
                                        </label>
                                        <input class="form-control d-none" value="" id="companylogo-image-input" type="file" accept="image/png, image/gif, image/jpeg" (change)="fileChange($event)">
                                    </div>
                                    <div class="avatar-lg p-1">
                                        <div class="avatar-title bg-light rounded-circle">
                                            <img src="assets/images/users/multi-user.jpg" id="companylogo-img" class="avatar-md h-auto rounded-circle object-fit-cover" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="company-field" class="form-label">Company</label>
                                <input type="text" id="company-field" class="form-control" formControlName="name" placeholder="Enter company name" required />
                            </div>

                            <div class="mb-3">
                                <label for="designation-field" class="form-label">Designation</label>
                                <input type="text" id="designation-field" class="form-control" formControlName="designation" placeholder="Enter designation" required />
                            </div>

                            <div class="mb-3">
                                <label for="date-field" class="form-label">Apply Date</label>
                                <input type="date" id="date-field" class="form-control" mwlFlatpickr [convertModelValue]="true" required formControlName="date" placeholder="Select date" />
                            </div>

                            <div class="mb-3">
                                <label for="contact-field" class="form-label">Contacts</label>
                                <input type="text" id="contact-field" class="form-control" placeholder="Enter contact" formControlName="contacts" required />
                            </div>

                            <div class="row gy-4 mb-3">
                                <div class="col-md-6">
                                    <div>
                                        <label for="status-input" class="form-label">Status</label>
                                        <select class="form-control" data-trigger name="status-input" id="status-input" formControlName="status">
                                            <option value="">Status</option>
                                            <option value="Approved">Approved</option>
                                            <option value="New">New</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Rejected">Rejected</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="type-input" class="form-label">Type</label>
                                        <select class="form-control" data-trigger name="type-input" id="type-input" formControlName="type">
                                            <option value="">Select Type</option>
                                            <option value="Full Time">Full Time</option>
                                            <option value="Part Time">Part Time</option>
                                        </select>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="modal.dismiss('close click')">Close</button>
                                <button type="submit" class="btn btn-success" id="add-btn">Add</button>
                            </div>
                        </div>
                    </form>
                </ng-template>

                <!-- Modal -->

                <ng-template #deletemodal role="document" let-modal>
                    <div class="modal-body p-5 text-center">
                        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#405189,secondary:#f06548" style="width:90px;height:90px">
                        </lord-icon>
                        <div class="mt-4 text-center">
                            <h4>You are about to delete a order ?</h4>
                            <p class="text-muted fs-15 mb-4">Deleting your order will remove all of your
                                information from our database.</p>
                            <div class="hstack gap-2 justify-content-center remove">
                                <button class="btn btn-link link-success fw-medium text-decoration-none" id="deleteRecord-close" data-bs-dismiss="modal" (click)="modal.dismiss('close click')"><i class="ri-close-line me-1 align-middle"></i> Close</button>
                                <button class="btn btn-danger" id="delete-record" (click)="deleteData(deleteId)">Yes,
                                    Delete
                                    It</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <!--end modal -->
            </div>
        </div>

    </div>
    <!--end col-->
</div>